(() => {
	angular.module('main').directive('addTodoModal', addTodoModal);

	addTodoModal.$inject = [
		'workflowService',
		'messageService',
		'validationService',
		'$rootScope'
	];

	function addTodoModal(
		workflowService,
		messageService,
		validationService,
		$rootScope
	) {
		return {
			restrict: 'E',
			scope: {
				jobId: '<',
				taskList: '=',
				fromSettings: '<',
				renewWorkflow: '&'
			},
			template: `<div id="addTodoModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="max-width: 670px">
        
                <form role="form" ng-submit="fromSettings ? saveTaskFromSettings(task, taskList, task.id) : saveTask()" name="addTodo">
                    <div class="modal-content">
                        <div class="modal-header">
                            <btn-close></btn-close>
                            <h3 class="modal-title">{{isForEdit ? 'Edit to-do' : 'Add a new to-do'}}</h3>
                        </div>
                        <div class="modal-body f-s-14-i">
                            <div class="form-group mb-8">
                           
        
                                <div class="row">
                                    <p class="col-xs-12">Task name</p>
                                    <div class="col-xs-12">
                                        <input type="text" autocomplete="off" class="form-control" ng-model="task.name" required>
                                    </div>
                                </div>
        
                                <hr class="mt-30 mb-30">
        
                                <div class="checkbox flex-row">
                                    <div class="checkbox-squared wf-label">
                                        <input id="checkbox-squared-has-due-date" type="checkbox" ng-model="task.hasDue">
                                        <label for="checkbox-squared-has-due-date"></label>
                                    </div>
                                    <label for="checkbox-squared-has-due-date" class="checker f-s-14-i">
                                        This task has a due date (will be flagged when overdue)
                                    </label>
                                </div>
        
                                <div class="row flex-row flex-align-center mt-20 flex-wrap-xs">
                                    <label class="col-xs-12 col-sm-1 control-label pull-left f-s-14-i">Due</label>
                                    <div class="col-xs-12 col-sm-2 numb-style mb-xs-10">
                                        <input ng-disabled="!task.hasDue" data-number-input min="1" class="form-control"
                                               type="number" autocomplete="off" ng-model="task.due" required>
                                    </div>
                                    <div class="col-xs-12 col-sm-4 mb-xs-10">
                                        <div class="select-style">
                                            <select ng-disabled="!task.hasDue"
                                                    ng-init="task.dateItem"
                                                    ng-model="task.dateItem"
                                                    ng-options="item for item in dateItems | orderBy">
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-5 mb-xs-10">
                                        <div class="select-style">
                                            <select ng-disabled="!task.hasDue"
                                                    ng-init="task.dateSequence"
                                                    ng-model="task.dateSequence"
                                                    ng-options="item.id as item.name for item in taskDateSequence">
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer modal-foot">
                            <button type="submit" class="btn btn-lg btn-success" spinning-wheel is-spinning-wheel-active="button_disabled" ng-disabled="button_disabled">Save workflow task</button>
                        </div>
                    </div>
                </form>
        
            </div>
        </div>
 `,
			replace: true,
			transclude: true,
			link(scope) {
				const todoModal = '#addTodoModal';

				$(document)
					.on('show.bs.modal', todoModal, () => {
						scope.taskToAnimateNumber = null;
						scope.taskInfo = workflowService.getTaskInfo();
						scope.isForEdit = scope.taskInfo.isForEdit;
						scope.task = angular.copy(scope.taskInfo.task);
						scope.taskDateSequence = workflowService.getTaskDateSequence();
						scope.dateItems = workflowService.getTaskDates();
						scope.$evalAsync();
					})
					.on('shown.bs.modal', todoModal, function() {
						$(this)
							.find('input')
							.first()
							.focus();
						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});

				scope.saveTaskFromSettings = (task, taskTypes, id) => {
					scope.button_disable = true;

					const isEdited = id !== null && id !== undefined;

					if (!workflowService.isTaskValid(task)) {
						scope.button_disabled = false;
						return;
					}

					scope.taskList = workflowService.pasteNewTaskInList(taskTypes, task); // modifies workflow list
					scope.taskList = workflowService.renewTaskViewDue(scope.taskList);

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					scope.button_disable = false;

					$(todoModal).modal('hide');
				};

				scope.successTaskSave = (data, id) => {
					if (!data || !data.tasks) {
						return;
					}

					scope.renewWorkflow({ tasks: data.tasks });

					for (let i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = `.task-${i}`;
						}
					}

					const isEdited = id !== null && id !== undefined;

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					$(todoModal)
						.modal('hide')
						.on('hidden.bs.modal', function() {
							if (!isEdited) {
								$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
							}
							$(this).off('hidden.bs.modal');
						});
				};

				scope.saveTask = () => {
					scope.button_disabled = true;
					const task2Save = scope.task;
					workflowService
						.saveTask(scope.task, scope.jobId, scope.taskList)
						.finally(() => {
							scope.button_disabled = false;
						})
						.subscribe(
							result => scope.successTaskSave(result, task2Save.id),
							result => workflowService.errorSaveTask(result.data)
						);
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addTodoModal.js